import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';
import VersionBadge from '../components/VersionBadge';

export default function AdvertiserAuth() {
  const navigate = useNavigate();
  const [mode, setMode] = useState('login');
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    email: '', password: '', company_name: '', contact_name: '',
    phone: '', website: '', category: 'brand'
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const endpoint = mode === 'signup' ? '/medulla/advertisers/signup' : '/medulla/advertisers/login';
      const payload = mode === 'signup' ? form : { email: form.email, password: form.password };
      const res = await axios.post(`${API}${endpoint}`, payload);
      localStorage.setItem('medulla_token', res.data.token);
      localStorage.setItem('medulla_advertiser', JSON.stringify(res.data.advertiser));
      toast.success(mode === 'signup' ? 'Welcome to Medulla!' : 'Welcome back!');
      navigate('/advertiser/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center p-4 relative">
      <div className="absolute top-4 left-4 text-xs text-green-400 font-mono tracking-widest">
        MEDULLA // MARKETING NEXUS
      </div>
      <Card className="w-full max-w-md p-8 bg-zinc-900/80 border-green-500/30 backdrop-blur">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold font-mono tracking-tight">
            <span className="text-green-400">M</span>edulla
          </h1>
          <p className="text-xs text-zinc-400 mt-1 tracking-widest">DATA-BIDDING MARKETPLACE</p>
        </div>

        <div className="flex gap-2 mb-6">
          <button
            data-testid="advertiser-login-tab"
            className={`flex-1 py-2 text-sm rounded ${mode === 'login' ? 'bg-green-500 text-black' : 'bg-zinc-800 text-zinc-400'}`}
            onClick={() => setMode('login')}
          >Log In</button>
          <button
            data-testid="advertiser-signup-tab"
            className={`flex-1 py-2 text-sm rounded ${mode === 'signup' ? 'bg-green-500 text-black' : 'bg-zinc-800 text-zinc-400'}`}
            onClick={() => setMode('signup')}
          >Sign Up</button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-3">
          {mode === 'signup' && (
            <>
              <Input data-testid="adv-company-name" placeholder="Company Name" value={form.company_name}
                onChange={(e) => setForm({ ...form, company_name: e.target.value })} required
                className="bg-zinc-800 border-zinc-700" />
              <Input data-testid="adv-contact-name" placeholder="Contact Name" value={form.contact_name}
                onChange={(e) => setForm({ ...form, contact_name: e.target.value })} required
                className="bg-zinc-800 border-zinc-700" />
              <select
                data-testid="adv-category"
                className="w-full bg-zinc-800 border border-zinc-700 rounded p-2 text-sm"
                value={form.category}
                onChange={(e) => setForm({ ...form, category: e.target.value })}
              >
                <option value="brand">Brand (liquor, beer, energy drinks, etc.)</option>
                <option value="local_business">Local Business (restaurant, retail)</option>
                <option value="other">Other</option>
              </select>
              <Input data-testid="adv-website" placeholder="Website (optional)" value={form.website}
                onChange={(e) => setForm({ ...form, website: e.target.value })}
                className="bg-zinc-800 border-zinc-700" />
              <Input data-testid="adv-phone" placeholder="Phone (optional)" value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                className="bg-zinc-800 border-zinc-700" />
            </>
          )}
          <Input data-testid="adv-email" type="email" placeholder="Email" value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })} required
            className="bg-zinc-800 border-zinc-700" />
          <Input data-testid="adv-password" type="password" placeholder="Password" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })} required
            className="bg-zinc-800 border-zinc-700" />

          <Button data-testid="adv-submit" type="submit" disabled={loading}
            className="w-full bg-green-500 hover:bg-green-400 text-black font-bold">
            {loading ? 'Please wait...' : (mode === 'signup' ? 'Create Advertiser Account' : 'Log In')}
          </Button>
        </form>

        <p className="text-xs text-zinc-500 text-center mt-4">
          Bid on ad slots. Reach thousands of nightlife patrons.
        </p>
      </Card>
      <VersionBadge />
    </div>
  );
}
